<script setup lang="ts">
import { corteLigado, funilVerPlanos } from "@/utils/eventosDoFunil";
import translaters from "@/tradutors/assine";
import { isMobile } from "@/shared/utils/mobile";
import AssineCreditsInformations from "@/components/Assine/AssineCreditsInformations.vue";
import {
  VueCollapsiblePanelGroup,
  VueCollapsiblePanel,
} from "@dafcoe/vue-collapsible-panel";
import "@dafcoe/vue-collapsible-panel/dist/vue-collapsible-panel.css";
import { CarrosselBella } from "#components";

const storeUser = userStore();
const storeAssineChoice = assineChoiceStore();
const route = useRoute();
const emit = defineEmits(["showModalMessages"]);

const props = defineProps(["plansCredits"]);
const isActiveUser = computed(() => storeUser.isActiveUser);
const isLoggedIn = computed(() => storeUser.isLoggedIn);

const disparobegin = ref(false);

const settings = ref({
  itemsToShow: 1.05,
  mouseDrag: false,
});
const breakpoints = ref({
  600: {
    itemsToShow: 2,
  },
});

onMounted(() => {
  if (props.plansCredits) {
    eventGTMViewCart();
    if (!disparobegin.value) {
      disparobegin.value = true;
      // eventGTMBeginCheckout()
    }
  }
});

function eventGTMViewCart() {
  // Depois do corte da medição: view_item_list no lugar do view_cart.
  if (corteLigado()) {
    funilVerPlanos("creditos", route.query.acionador);
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "view_cart",
    cart: {
      tipo: "creditos",
    },
  });
}

const reactiveLocale = computed(() => route.params.language); // Certifique-se de que locale é uma ref

const translate = computed(() => {
  if (reactiveLocale.value === "pt-br") {
    return translaters.portugues;
  } else {
    return translaters.ingles;
  }
});

function saveChoiceAssinante() {
  let checkRadio = document.querySelector(
    'input[name="plansCreditsAssinante"]:checked'
  ) as HTMLInputElement;
  if (checkRadio != null) {
    storeAssineChoice.setAssineChoice({
      choiceId: parseInt(checkRadio.value),
      choiceType: "credits",
    });
    storeAssineChoice.setAssineChoiceTurbo(0);
    if (!isActiveUser.value) {
      emit("showModalMessages", {
        message: {
          show: true,
          title: reactiveLocale.value == "pt-br" ? "Aviso" : "Notice",
          textButton: reactiveLocale.value == "pt-br" ? "Login" : "Login",
          textBoby: translate.value.credits.subscribeInfo,
          routerName: "language-assine-account",
        },
      });
    } else {
      redirect("language-assine-checkout");
    }
  } else {
    emit("showModalMessages", {
      message: {
        show: true,
        title: reactiveLocale.value == "pt-br" ? "Aviso" : "Notice",
        textButton: reactiveLocale.value == "pt-br" ? "Fechar" : "Close",
        textBoby:
          reactiveLocale.value == "pt-br"
            ? "Escolha uma opção para Assinantes"
            : "Choose an option for Subscribers",
      },
    });
  }
}

const choice = ref({
  choiceTitle: "Não definido",
  choiceValue: 0,
});

function eventGTMSelectPlan() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "select_plan",
    select_plan: {
      tipo:
        storeAssineChoice.choiceType !== "credits" ? "assinatura" : "credito",
      acionador: route.query.acionador ?? "link direto",
      currency: reactiveLocale.value === "pt-br" ? "BRL" : "USD",
      value: choice.value.choiceValue ?? 0,
      plano: choice.value.choiceTitle,
    },
  });
}

function radioCicked(plan: any) {
  //Verifica o valor e o nome do plano a enviar para o GTM
  choice.value.choiceTitle =
    (isActiveUser.value
      ? plan.creditLivesAssinantes
      : plan.creditLivesNaoAssinantes) +
    (reactiveLocale.value == "pt-br"
      ? " Créditos para Downloads"
      : " Downloads Credits");
  choice.value.choiceValue =
    Number(plan.discount) > 0 && plan.discount_value && plan.discount_value != plan.value  
      ? +plan.discount_value
      : +plan.value;

  eventGTMSelectPlan();
}

function saveChoiceNaoAssinante() {
  let checkRadio = document.querySelector(
    'input[name="plansCreditsNaoAssinante"]:checked'
  ) as HTMLInputElement;
  if (checkRadio != null) {
    storeAssineChoice.setAssineChoice({
      choiceId: parseInt(checkRadio.value),
      choiceType: "credits",
    });
    storeAssineChoice.setAssineChoiceTurbo(0);
    if (isLoggedIn.value) {
      redirect("language-assine-checkout");
    } else {
      redirect("language-assine-account");
    }
  } else {
    emit("showModalMessages", {
      message: {
        show: true,
        title: reactiveLocale.value == "pt-br" ? "Aviso" : "Notice",
        textButton: reactiveLocale.value == "pt-br" ? "Fechar" : "Close",
        textBoby:
          reactiveLocale.value == "pt-br"
            ? "Escolha uma opção para Não Assinantes"
            : "Choose an option for Non-Subscribers",
      },
    });
  }
}
const router = useRouter();

function redirect(name: string) {
  router.push({
    name,
    params: {
      language: reactiveLocale.value,
    },
    query: {
      acionador: route.query.acionador,
    },
  });
}

const cards = [
  {
    id: 1,
    type: "assinates",
  },
  {
    id: 2,
    type: "non-assinates",
  },
];
</script>

<template>
  <div class="row d-flex justify-content-center">
    <div class="col-lg-12">
      <div
        v-if="isActiveUser"
        class="add-credits-message"
      >
        <div class="add-credits-title">{{ translate.addCredits1 }}</div>
        <div class="add-credits-subtitle">{{ translate.addCredits2 }}</div>
        <div class="add-credits-text">
          {{ translate.addCredits3 }}<b>{{ translate.addCredits4 }}</b>{{ translate.addCredits5 }}
        </div>
      </div>
      <CarrosselBella :cards="cards" :active-index="isActiveUser ? 0 : 1">
        <template #default="{ item, index }">
          <template v-if="index === 0">
            <div class="card">
              <div class="card-body justify-content-center">
                <div class="credit-title">
                  {{ translate.credits.PlansAssi }}
                </div>
                <div class="credit-subtitle">
                  {{ translate.credits.option }}
                </div>
                <div class="credit-hr"></div>
                <div
                  class="row d-flex align-items-center justify-content-center"
                  v-for="(item, index) in props.plansCredits"
                  :key="item.id"
                  :class="{ 'bg-gray': index % 2 !== 0 }"
                >
                  <div
                    class="credit-discount"
                    v-if="
                      index == 0 && item.discount > 0 && item.discount_value && item.discount_value != item.value
                    "
                  >
                    <div>{{ translate.PromotionSpecial }}</div>
                    <div>
                      {{ item.discount }} % {{ translate.labelDiscont }}
                    </div>
                  </div>
                  <div
                    v-if="index > 0"
                    class="col-12 d-flex justify-content-end"
                  >
                    <div class="col-10 credit-items-hr"></div>
                  </div>
                  <div class="col-2 credit-items">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="plansCreditsAssinante"
                      :value="item.id"
                      @click="radioCicked(item)"
                    />
                  </div>
                  <div class="col-5 credit-items credit-amount">
                    {{ item.creditVideosAssinantes }}
                    {{ reactiveLocale == "en" ? "credits" : "créditos" }}
                  </div>
                  <div class="col-5 credit-items">
                    <div
                      class="credit-value-cancel"
                      v-if="item.discount > 0 && item.discount_value && item.discount_value != item.value"
                    >
                      {{ reactiveLocale === "pt-br" ? "De " : "Of " }}
                      {{ reactiveLocale != "pt-br" ? "$" : "" }}
                      {{ item.value }}
                    </div>
                    <span
                      class="credit-value"
                      v-if="item.discount > 0 && item.discount_value && item.discount_value != item.value"
                    >
                      {{ reactiveLocale === "pt-br" ? "Por " : "Only " }}
                      {{ reactiveLocale != "pt-br" ? "$" : "" }}
                      <span
                        >{{
                          item.discount_value.toString().split(".")[0]
                        }},</span
                      >
                      <span class="credit-value-cents">
                        {{ item.discount_value.toString().split(".")[1] }}
                      </span>
                    </span>
                    <span class="credit-value" v-if="!item.discount_value || item.discount_value == item.value">
                      {{ reactiveLocale != "pt-br" ? "$" : "" }}
                      <span>{{ item.value.toString().split(".")[0] }},</span>
                      <span class="credit-value-cents">
                        {{ item.value.toString().split(".")[1] }}
                      </span>
                    </span>
                  </div>
                  <div
                    v-if="index == 0 && route.params.language == 'pt-br'"
                    class="parcelamento"
                  >
                    À vista ou em até 3x de
                    {{
                      (
                        (item.discount_value && item.discount_value != item.value
                          ? item.discount_value
                          : item.value) / 3
                      ).toFixed(2)
                    }}
                    sem juros
                  </div>
                </div>
                <div
                  class="row d-flex align-items-center justify-content-center"
                >
                  <button
                    type="button"
                    class="credit-button"
                    @click="saveChoiceAssinante()"
                  >
                    {{ translate.buttonCreditsAssinante }}
                  </button>
                </div>
                <div class="d-flex justify-content-center" v-if="isMobile()">
                  <div class="col-12">
                    <vue-collapsible-panel-group base-color="#2d2b3b">
                      <vue-collapsible-panel :expanded="false">
                        <template #title>
                          <div class="details">{{ translate.moreDetails }}</div>
                        </template>
                        <template #content>
                          {{ " " }}
                          <div class="col-12">
                            <ul class="bulleted-list">
                              <li
                                v-for="(list, index) in translate.credits
                                  .listBenefits"
                                :key="index"
                              >
                                <p class="ps-2 list-items" v-html="list"></p>
                              </li>
                            </ul>
                          </div>
                        </template>
                      </vue-collapsible-panel>
                    </vue-collapsible-panel-group>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex mt-3">
              <div class="credits-subs-hiffen">-</div>
              <div class="credits-subs-info">
                {{ translate.credits.subscribeInfo }}
              </div>
            </div>
          </template>
          <template v-else-if="index === 1">
            <div
              :class="`card ${isActiveUser && isLoggedIn ? 'card-gray' : ''}`"
            >
              <div class="card-body justify-content-center">
                <div class="credit-title">
                  {{ translate.credits.PlansNoAssi }}
                </div>
                <div class="credit-subtitle">
                  {{ translate.credits.option }}
                </div>
                <div class="credit-hr"></div>
                <div
                  class="row d-flex align-items-center justify-content-center"
                  v-for="(item, index) in props.plansCredits"
                  :key="item.id"
                  :class="{ 'bg-gray': index % 2 !== 0 }"
                >
                  <div
                    class="credit-discount"
                    v-if="
                      index == 0 && item.discount > 0 && item.discount_value && item.discount_value != item.value
                    "
                  >
                    <div>{{ translate.PromotionSpecial }}</div>
                    <div>
                      {{ item.discount }} % {{ translate.labelDiscont }}
                    </div>
                  </div>
                  <div
                    v-if="index > 0"
                    class="col-12 d-flex justify-content-end"
                  >
                    <div class="col-10 credit-items-hr"></div>
                  </div>
                  <div class="col-2 credit-items">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="plansCreditsNaoAssinante"
                      :value="item.id"
                      @click="radioCicked(item)"
                    />
                  </div>
                  <div class="col-5 credit-items credit-amount">
                    {{ item.creditVideosNaoAssinantes }}
                    {{ reactiveLocale == "en" ? "credits" : "créditos" }}
                  </div>
                  <div class="col-5 credit-items">
                    <div
                      class="credit-value-cancel"
                      v-if="item.discount > 0 && item.discount_value && item.discount_value != item.value"
                    >
                      {{ reactiveLocale === "pt-br" ? "De " : "Of " }}
                      {{ reactiveLocale != "pt-br" ? "$" : "" }}
                      {{ item.value }}
                    </div>
                    <span
                      class="credit-value"
                      v-if="item.discount > 0 && item.discount_value && item.discount_value != item.value"
                    >
                      {{ reactiveLocale === "pt-br" ? "Por " : "Only " }}
                      {{ reactiveLocale != "pt-br" ? "$" : "" }}
                      <span
                        >{{
                          item.discount_value.toString().split(".")[0]
                        }},</span
                      >
                      <span class="credit-value-cents">
                        {{ item.discount_value.toString().split(".")[1] }}
                      </span>
                    </span>
                    <span class="credit-value" v-if="!item.discount_value || item.discount_value == item.value">
                      {{ reactiveLocale != "pt-br" ? "$" : "" }}
                      <span>{{ item.value.toString().split(".")[0] }},</span>
                      <span class="credit-value-cents">
                        {{ item.value.toString().split(".")[1] }}
                      </span>
                    </span>
                  </div>
                  <div
                    v-if="index == 0 && route.params.language == 'pt-br'"
                    class="parcelamento"
                  >
                    À vista ou em até 3x de
                    {{
                      (
                        (item.discount_value
                          ? item.discount_value
                          : item.value) / 3
                      ).toFixed(2)
                    }}
                    sem juros
                  </div>
                </div>
                <div
                  class="row d-flex align-items-center justify-content-center"
                >
                  <button
                    v-if="isActiveUser && isLoggedIn"
                    type="button"
                    class="credit-button-inactive col-lg-3 col-8`"
                  >
                    {{ translate.buttonCredits2 }}
                  </button>
                  <button
                    v-else
                    type="button"
                    class="credit-button col-lg-3 col-8`"
                    @click="saveChoiceNaoAssinante()"
                  >
                    {{ translate.buttonCredits2 }}
                  </button>
                </div>
                <div class="d-flex justify-content-center" v-if="isMobile()">
                  <div class="col-12">
                    <vue-collapsible-panel-group base-color="#2d2b3b">
                      <vue-collapsible-panel :expanded="false">
                        <template #title>
                          <div class="details">{{ translate.moreDetails }}</div>
                        </template>
                        <template #content>
                          {{ " " }}
                          <div class="col-12">
                            <ul class="bulleted-list">
                              <li
                                v-for="(list, index) in translate.credits
                                  .listBenefits"
                                :key="index"
                              >
                                <p class="ps-2 list-items" v-html="list"></p>
                              </li>
                            </ul>
                          </div>
                        </template>
                      </vue-collapsible-panel>
                    </vue-collapsible-panel-group>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
      </CarrosselBella>
      <div class="container col-lg-12 col-12 py-5" v-if="!isMobile()">
        <AssineCreditsInformations />
      </div>
    </div>
  </div>
</template>

<style scoped lang="css">
.card {
  border: 3px solid #6fa923;
  width: 100%;
  margin-top: 50px;
  padding: 0px;
  border: solid 3px transparent;
  background: linear-gradient(#ffffff, #ffffff) padding-box,
    radial-gradient(98.54% 262.92% at 1.46% 0%, #ff6000 0%, #ffe3d2 100%)
      border-box;
  border-radius: 25px 25px 0 0;
}

:deep(.carousel__slide.carousel__slide--visible) {
  display: flex;
  flex-direction: column;
  padding: 10px;
  justify-content: flex-start;
}

:deep(.carousel) {
  max-height: 100%;
  height: unset;
}

.card-gray {
  background: linear-gradient(#ffffff, #ffffff) padding-box,
    radial-gradient(98.54% 262.92% at 1.46% 0%, #eaeaea 0%, #cccccc 100%)
      border-box !important;
}

.credit-title {
  font-family: "Exo-2";
  font-weight: 700;
  font-size: 28.28px;
  line-height: 33.94px;
  color: #000000;
  padding-top: 10px;
  text-align: center;
}

.credit-subtitle {
  font-family: "Exo-2";
  font-weight: 400;
  font-size: 15.56px;
  line-height: 18.67px;
  color: #4b4b4b;
  padding-top: 20px;
  text-align: center;
}

.credit-hr {
  margin-left: 50%;
  transform: translateX(-50%);
  margin-top: 10px;
  border-top: 1px solid #9d9d9d;
  width: 80%;
}

.credit-items {
  padding: 20px 0px;
}

.credit-items-hr {
  border-top: 1px solid #dedede;
  right: 10px;
}

.credit-amount {
  font-family: "Exo-2";
  font-weight: 300;
  font-size: 20px;
  line-height: 24px;
  color: #000000;
}

.credit-value {
  font-family: "Exo-2";
  font-weight: 800;
  font-size: 20px;
  line-height: 24px;
  color: #000000;
}

.credit-value-cents {
  font-size: 13px;
}

.credit-value-cancel {
  font-family: "Exo-2";
  font-weight: 400;
  font-size: 15px;
  line-height: 19px;
  color: #b20000;
  text-decoration: line-through;
}

.credit-button {
  width: unset;
  min-width: 206px;
  min-height: 46px;
  background-color: #ff6000 !important;
  border-radius: 15px !important;
  font-family: "Exo-2";
  font-weight: 700;
  font-size: 19px;
  line-height: 23.76px;
  color: #ffffff;
  margin-top: 30px;
  margin-bottom: 20px;
}

.credit-button-inactive {
  width: 206px;
  height: 46px;
  background-color: #eaeaea !important;
  border-radius: 15px !important;
  font-family: "Exo-2";
  font-weight: 700;
  font-size: 19.8px;
  line-height: 23.76px;
  color: #ffffff;
  margin-top: 30px;
  margin-bottom: 20px;
  cursor: not-allowed;
}

.credits-subs-hiffen {
  font-family: "Exo-2";
  font-weight: 300;
  font-size: 12px;
  line-height: 14.4px;
  color: #4b4b4b;
}
.credits-subs-info {
  text-align: justify;
  width: 90%;
  left: 10px;
  font-family: "Exo-2";
  font-weight: 300;
  font-size: 12px;
  line-height: 14.4px;
  color: #4b4b4b;
}
.form-check-input:checked[type="radio"] {
  --bs-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23000'/%3e%3c/svg%3e");
}

.form-check-input:checked {
  background-color: #ffffff;
  border-color: #000;
}

.form-check-input {
  --bs-form-check-bg: #fff;
  width: 24px;
  height: 24px;
  left: 15px;
}

.carousel__slide {
  display: inline;
}

.details {
  font-family: "Roboto-Medium";
  font-weight: 400;
  font-size: 17px;
  line-height: 19px;
  color: #000000;
}

.list-items {
  font-family: "Roboto-Regular";
  font-weight: 400;
  font-size: 11px;
  line-height: 12.89px;
  color: #000000;
  text-align: left;
}

.bulleted-list {
  list-style-type: disc;
  margin-left: 20px;
}
.bulleted-list li {
  margin-bottom: 0px;
  text-align: left;
}

.footer-list {
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 13px;
  font-style: italic;
  letter-spacing: 0;
  line-height: 15px;
  padding-top: 30px;
  text-align: left;
}

.credit-discount {
  font-family: "Exo-2";
  font-weight: 700;
  font-size: 21.2px;
  color: #436a10;
  padding: 10px 0px;
  text-align: center;
  line-height: 30px;
}

.add-credits-message {
  padding: 16px 12px 8px 12px;
  text-align: center;
  width: 50%;
  margin: 0 auto;
}

.add-credits-title {
  font-family: "Roboto-Medium";
  font-weight: 700;
  font-size: 28px;
  line-height: 1.1;
  color: #ff6000;
  margin-bottom: 8px;
}

.add-credits-subtitle {
  font-family: "Exo-2";
  font-weight: 500;
  font-size: 20px;
  line-height: 1.3;
  color: #000000;
  margin-bottom: 14px;
}

.add-credits-text {
  font-family: "Exo-2";
  font-weight: 400;
  font-size: 20px;
  line-height: 1.4;
  color: #000000;
  padding: 0 8px;
}

.add-credits-text b {
  font-weight: 700;
}

.parcelamento {
  font-family: "Exo-2";
  font-weight: 250;
  font-size: 16px;
  line-height: 19.2px;
  color: #8c8c8c;
  left: 50px;
  top: -15px;
}

.vcpg {
  border: none !important;
}

.vcpg :deep(.vcp__header) {
  background-color: unset !important;
  border: 0;
  width: 100%;
  margin-left: 50%;
  transform: translateX(-50%);
}

/* regras mobile 769px */
@media screen and (max-width: 769px) {
  .add-credits-message {
    width: 100%;
  }

  .credit-amount {
    font-size: 16px;
    line-height: 19.2px;
    left: 0px;
  }
  .card-body {
    min-height: 500px;
  }

  .credit-value {
    font-size: 16px;
    line-height: 19.2px;
  }

  .parcelamento {
    left: 30px;
    font-size: 13px;
  }
  :deep(.carousel) {
    padding-bottom: 1rem;
  }
  :deep(.carousel-pagination) {
    margin-top: -1rem;
    z-index: 1;
  }

  :deep(.carousel__slide.carousel__slide--visible) {
    padding: 0px;
  }  
  .add-credits-subtitle {
    font-size: 16px;
  }

  .add-credits-text {
    font-size: 16px;
  }
  .credit-button {
    font-size: 15px;
  }
}
</style>
